import { ConversationFormValues } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { getFormValues, InjectedFormProps } from 'redux-form';

import { appActions } from 'app/app.actions';
import { bindRtkActionToPromise } from 'app/utils/promiseActions';
import { AppDispatch, AppState } from 'bootstrap.store';
import { AddUserPayload, userModalActions } from 'components/usersModal';
import { RouteComponentProps, withRouter } from 'hocs/router';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { websocketActions } from '../../../app/middleware/websocket/actions/websocket';
import { selectQuickResponseTemplates } from '../../../app/utils/reselect';
import { notificationActions } from '../../notifications/actions/notification';
import * as personalActions from '../../settings/actions/personal';
import { templatesActions } from '../../settings/actions/templates';
import { composeEmailActions } from '../../shared/composeEmail/actions/composeEmailActions';
import { hasFeature } from '../../shared/featureFlag';
import { richTextFieldActions } from '../../shared/util/richTextField/actions/richTextField';
import { actions } from '../actions/conversation';
import * as typingActions from '../actions/typing';
import ConversationForm from '../components/ConversationForm';
import { getLastEndUserMessage } from '../selectors';
import { getConversationFormName } from '../utils/conversationForm';

const { personalSubmitMessageWithEnter } = personalActions.actions;
const { typingSend } = typingActions.actions;

const { notificationAdd } = notificationActions;

const mapStateToProps = (state) => {
  const metaConversation = state.conversation.metaConversation;
  const fromEmails = state.composeEmail.fromEmails;
  const csid = metaConversation.conversation.id;

  const isUploadingAttachments =
    state.richTextField.meta.addAttachments === 'loading' ||
    state.conversationForm.meta.addAttachments === 'loading'
      ? true
      : false;
  const form = getConversationFormName(csid);
  const formValues = getFormValues(form)(state);
  const tempFormValues = state.conversation.metaConversation.tempFormValues;

  return {
    asyncStatus: state.conversation.asyncStatus,
    composeEmailMeta: state.composeEmail.meta,
    form,
    formValues,
    tempFormValues,
    fromEmails,
    getAllFromAsyncStatus: state.composeEmail.meta.getAllFrom,
    hasFFWriteHTMLEmail: hasFeature(state, 'write-html-email'),
    isUploadingAttachments,
    lastEndUserMessage:
      state.conversation.metaConversation && getLastEndUserMessage(state),
    metaConversation: state.conversation.metaConversation,
    profile: state.settings.profile.profile,
    personalSettings: state.settings.personal,
    quickResponseTemplates: selectQuickResponseTemplates(state),
    users: state.composeEmail.users,
    organizationName: state.settings.organization.organization.name,
    hasSmartReplyFeatureFlag: hasFeature(state, 'knowledge-ai-draft'),
    elevioSmartReplyData: (state as AppState).elevio.aiResponse.data,
    knowledgeSmartReplyMessage: state.knowledge.smartConversationReply.message,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    composeEmailFindUser: bindActionToPromise(
      dispatch,
      composeEmailActions.composeEmailFindUser,
    ),
    composeEmailGetAllFrom: bindActionToPromise(
      dispatch,
      composeEmailActions.composeEmailGetAllFrom,
    ),
    conversationUnmount: () => dispatch(actions.conversationUnmount()),
    conversationSaveTempMessage: (csid: string, message: string) =>
      dispatch(
        actions.conversationSaveTempMessage({ csid: csid, message: message }),
      ),
    conversationSaveTempFormValues: (
      csid: number,
      formValues: ConversationFormValues | null,
    ) => dispatch(actions.conversationSaveTempFormValues({ csid, formValues })),
    conversationSubmitMessage: bindActionToPromise(
      dispatch,
      actions.conversationSubmitMessage,
    ),
    notificationAdd: (payload) => dispatch(notificationAdd(payload)),
    personalSubmitMessageWithEnter: bindActionToPromise(
      dispatch,
      personalSubmitMessageWithEnter,
    ),
    richTextFieldAddAttachments: bindActionToPromise(
      dispatch,
      richTextFieldActions.richTextFieldAddAttachments,
    ),
    templatesRender: bindActionToPromise(
      dispatch,
      templatesActions.templatesRender,
    ),
    typingSend: bindActionToPromise(dispatch, typingSend),
    userModalAddUser: (payload: AddUserPayload) =>
      dispatch(userModalActions.user.add(payload)),
    wsRequest: bindRtkActionToPromise(dispatch, websocketActions.request),
    showPublicReplyConfirmModal: () => {
      return dispatch(
        appActions.showModal({
          modal: {
            type: 'app:confirm',
            arg: {
              title: 'Public reply',
              description:
                'Replying to a mention will make your response public. Remember to make sure that the response is appropriate for a public forum.',
              confirm: { label: 'Yes, send now', variant: 'primary' },
            },
          },
        }),
      );
    },
  };
};

type ConversationFormStateProps = ReturnType<typeof mapStateToProps>;
type ConversationFormDispatchProps = ReturnType<typeof mapDispatchToProps>;

export type ConversationFormInjectedProps = ConversationFormStateProps &
  ConversationFormDispatchProps &
  InjectedFormProps &
  RouteComponentProps;

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ConversationForm),
);
